// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_dict from "../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as GeoRegion from "../../../../common/store/GeoRegion.bs.js";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";

function getIneligibleCardString(geo_region, vehicle_category, config, content) {
  var region = Js_dict.get(config, GeoRegion.toString(geo_region));
  if (region === undefined) {
    return content.ineligibleCardDefaultText;
  }
  var vehicle_config = Js_dict.get(Caml_option.valFromOption(region), vehicle_category);
  if (vehicle_config !== undefined) {
    return Curry._2(content.getIneligibleCardDynamicText, String(vehicle_config.login_hours), String(vehicle_config.completion_score));
  } else {
    return content.ineligibleCardDefaultText;
  }
}

export {
  getIneligibleCardString ,
  
}
/* No side effect */
